import {useEffect} from 'react'
import {createUseStyles} from 'react-jss'
import {useNavigate, useParams} from "react-router-dom";
import {Colors} from '../constants/colors'
import CardSection from '../components/CardSection'
import DetailsCard from '../components/DetailsCard'
import {formatDateTimeString} from '../utils/dateHelper'
import {useAppSelector} from '../redux/hooks';
import FullScreenLoadingIndicator from '../components/FullScreenLoadingIndicator';
import Divider from '../components/Divider';
import {faArrowLeft} from "@fortawesome/free-solid-svg-icons";
import NavLink from '../components/NavLink';
import {titleMarginBottom} from '../constants/layout';
import useCreditFacilityPayoutActions from '../hooks/useCreditFacilityPayoutActions';
import {formatMoney} from '../utils/moneyHelper';

const CreditFacilityPayoutDetails = () => {
  const styles = useStyles()
  const params = useParams<{facilityId: string, payoutId: string}>()
  const navigate = useNavigate();

  const loading = useAppSelector(state => state.creditFacilityPayout.loading)
  const payout = useAppSelector(state => state.creditFacilityPayout.payoutDetails)

  const {
    getCreditFacilityPayoutDetailsById
  } = useCreditFacilityPayoutActions()

  useEffect(() => {
    if (params.payoutId) {
      if ((payout?.id === null || payout?.id !== params.payoutId) && params.facilityId) {
        getCreditFacilityPayoutDetailsById(params.facilityId || '', params.payoutId || '')
      }
    }
  }, [])

  const renderGeneralCardBody = () => {
    return (
      <div>
        <p>State: <span>{payout?.state}</span></p>
        <p>Failure reason: <span>{payout?.failureReason}</span></p>
        <p>Created: <span>{formatDateTimeString(payout?.created)}</span></p>
        <p>Completed: <span>{formatDateTimeString(payout?.completedDate)}</span></p>
        <p>Amount: <span>{formatMoney(payout?.amount)}</span></p>
        <p>Repayment date: <span>{formatDateTimeString(payout?.repaymentDate)}</span></p>
      </div>
    )
  }

  const renderIntentCardBody = () => {
    return (
      <div>
        <p>Payout intent: <span>{payout?.payoutIntentId}</span></p>
        <p>Customer reference intent ID: <span>{payout?.customerReferenceIntentId}</span></p>
        <p>Customer reference payout ID: <span>{payout?.customerReferencePayoutId}</span></p>
      </div>
    )
  }

  const renderUserCardBody = () => {
    return (
      <div>
        <p>User: <span>{payout?.userId}</span></p>
        <p>Recipient identification number: <span>{payout?.recipientIdentificationNumber}</span></p>
      </div>
    )
  }

  const renderPayoutMethodCardBody = () => {
    return (
      <div>
        <p>Type: <span>{payout?.payoutMethodType}</span></p>
        <p>Target: <span>{payout?.payoutMethodTarget}</span></p>
      </div>
    )
  }

  return (
    <div className={styles.container}>
      <h1>Credit facility payout: {formatDateTimeString(payout?.created)}</h1>
      <div className={styles.actionBar}>
        <div className={styles.actionBarCell} style={{justifyContent: 'flex-start'}}>
          <NavLink title='Back' icon={faArrowLeft} onClick={() => navigate(-1)} />
        </div>
        <div className={styles.actionBarCell} style={{justifyContent: 'flex-end'}}>
        </div>
      </div>
      <CardSection>
        <DetailsCard>
          <h6>General</h6>
          {renderGeneralCardBody()}
        </DetailsCard>
        <DetailsCard>
          <h6>Intent</h6>
          {renderIntentCardBody()}
        </DetailsCard>
        <DetailsCard>
          <h6>User</h6>
          {renderUserCardBody()}
        </DetailsCard>
        <DetailsCard>
          <h6>Payout method</h6>
          {renderPayoutMethodCardBody()}
        </DetailsCard>
      </CardSection>
      <Divider height={50}/>
      <FullScreenLoadingIndicator visible={loading} />
    </div>
  )
}

export default CreditFacilityPayoutDetails

const useStyles = createUseStyles({
  container: {
    '& h1': {
      marginBottom: titleMarginBottom
    },
    '& h5': {
      fontFamily: 'Aestetico-Regular',
      color: Colors.darkDefault,
    }
  },
  actionBar: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  actionBarCell: {
    display: 'flex',
    flexDirection: 'row',
    columnGap: 15,
    alignItems: 'center',
    width: '33%'
  },
  navLinkContainer: {
    display: 'flex',
    flexDirection: 'row',
    columnGap: 10
  }
})
